/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { reads } from 'macro-decorators';
import { action, get } from '@ember/object';
/* eslint-enable @typescript-eslint/no-unused-vars */
let FreestyleSource = (_dec = service('ember-freestyle'), _dec2 = reads('args.dynamicProperties', {}), (_class = class FreestyleSource extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "emberFreestyle", _descriptor, this);
    _initializerDefineProperty(this, "dynamicProperties", _descriptor2, this);
    _initializerDefineProperty(this, "initialHighlightComplete", _descriptor3, this);
    _defineProperty(this, "preElement", void 0);
  }
  dynamafy(sourceCode) {
    const dynamicProperties = this.dynamicProperties;
    Object.keys(dynamicProperties).forEach(property => {
      const propertyValue = get(dynamicProperties, `${property}.value`);
      const type = typeof propertyValue;
      const quote = this.args.useDoubleQuotesForStrings ? `"` : `'`;
      const angleAssignmentVal = type === 'string' ? `${quote}${propertyValue}${quote}` : `{{${propertyValue}}}`;
      const curlyAssignmentVal = type === 'string' ? `${quote}${propertyValue}${quote}` : propertyValue;
      const expressionVal = propertyValue;

      // First, replace in-block dynamic properties
      sourceCode = sourceCode.replace(`={{dynamic.${property}}}`, `=${angleAssignmentVal}`);
      sourceCode = sourceCode.replace(`=dynamic.${property}`, `=${curlyAssignmentVal}`);
      sourceCode = sourceCode.replace(`{{dynamic.${property}}}`, expressionVal);
    });
    return sourceCode;
  }
  get renderableSource() {
    if (!this.args.source) {
      return '';
    }
    let result = this.args.source.replace(/^(\s*\n)*/, '').replace(/\s*$/, '');
    if (this.args.isDynamic) {
      result = this.dynamafy(result);
    }
    if (this.initialHighlightComplete && this.preElement) {
      // highlight.js breaks binding, so we need to manually reset the innerText on changes
      // eslint-disable-next-line ember/no-side-effects
      this.preElement.innerText = result;
      // ...and then do the syntax highlighting again
      this.emberFreestyle.highlight(this.preElement);
    }
    return result;
  }
  highlight(preElement) {
    this.preElement = preElement;
    if (preElement && this.renderableSource) {
      this.emberFreestyle.highlight(preElement);
    }
    this.initialHighlightComplete = true;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "emberFreestyle", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dynamicProperties", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "initialHighlightComplete", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "highlight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "highlight"), _class.prototype)), _class));
export { FreestyleSource as default };